import axios, {
  axiosBase,
  axiosReport,
  axiosNotification,
  axiosDocument,
  axiosNotes,
  axiosMarketplaceVendor,
  axiosDocLibrary,
  axiosFom,
} from "./axios";

import { getVendorStatusDetailsInterceptor } from "./interceptors";

// Setup response interceptors
axios().interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      getVendorStatusDetailsInterceptor(response);
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const httpGetUIEnv = () => axiosBase().get("/ui-env");
export const httpGetPublicUIEnv = () => axiosBase().get("/pub/ui-env");

// use fetch instead of axios to handle blob content
export const httpGetFileContent = (url) => {
  return fetch(`/download/${url}`);
};

export const httpGetWorkflowSteps = () =>
  axios().get("/vendorWorkflowStatus/getWorkflowSteps");

export const httpGetUserPermission = (submitData) =>
  axios().post("/admin/getUserPermission/", submitData);

export const httpGetSavedUPSAccountsAndAddress = (vendorProfileId, category) =>
  axios().get(
    `/address/getAddressByIdAndCategory/${vendorProfileId}/${category}`
  );

export const httpGetVendorDetailsByDuns = (dunsNo) =>
  axios().get(`/vendorProfile/getVendorDetailsByDun/${dunsNo}`);

export const httpGetVendorProfileById = (vendorId) =>
  axios().get(`/vendorProfile/getVendorByProfileId/${vendorId}`);

export const httpGetVendorProfileByEmail = (email) =>
  axios().get(`/vendorProfile/getVendorProfileByEmail/${email}`);

export const httpGetVendorStatusDetails = (vendorId) =>
  axios().get(`/vendorProfile/getVendorStatusByprofileId/${vendorId}`);

export const httpGetThreeNotesByProfileId = (vendorProfileId) =>
  axiosNotes().get(`/vendorNote/getTopThreeNotesByVendorId/${vendorProfileId}`);

export const httpPostReturnVendorToMerchant = (submitData) =>
  axios().post("/vendorProfile/returnVendorByMerchant", submitData);

export const httpPostAdditionalAccessRequestForVendor = (submitData) =>
  axios().post("/registration/vendor-access-request", submitData);

export const httpPostAddContactExternalVendor = (submitData) =>
  axios().post("/registration/addVendor", submitData);

export const httpGetAdditionalAccessRequestForVendor = () =>
  axios().get("/registration/vendor-access-request-by-status/Requested");

export const httpPostUpdateAdditionalAccessRequestForVendor = (submitData) =>
  axios().post("/registration/update-vendor-access-request", submitData);

export const httpGetDeploymentStatus = () =>
  axios().get("/configuration/deploybanner");

export const httpGetConfigValues = () => axios().get("/configuration");

export const httpGetAllVendorProfileList = () =>
  axios().get(`/vendorProfile/getAllVendorProfileList`);

export const httpGetAllHierarchyDivision = () =>
  axios().get("/mchHier/getAllMchHierOperDivnNm");

export const httpGetHierarchyByDivisionNumber = (divisionNumber) =>
  axios().get(`/mchHier/getMchHierByOperDivnNm/${divisionNumber}`);
export const httpGetHierarchyAllBrandNames = (vendorId) =>
  axios().get(`/vendorProfile/brand-name/${vendorId}`);

export const httpPostSendAccountPayableEmail = (data) =>
  axios().post("/accountsPayable/requestDetails", data);

export const httpPostRequestNewDVN = (data) =>
  axios().post("/accountsPayable/requestNewDVN", data);

export const httpPostSendMerchantApprovalMoreDetailsEmail = (data) =>
  axios().post("/merchant/requestDetails", data);

export const httpPostSaveVendorStatusByProfileId = (data) =>
  axios().post("/vendorProfile/saveVendorStatusByprofileId", data);

export const httpGetEmailAdmin = (roleName) => {
  return axiosNotification().get(
    `/email/templates?type=CUSTOM&roleName=${roleName}`
  );
};

export const httpGetAllUsersForPipeLineOwnerRole = () => {
  return axios().get("/admin/getAllUsersForPipeLineOwnerRole");
};

export const httpPostUpdateVendorProfile = (data) =>
  axios().post("/vendorProfile/updateVendor", data);

export const httpGetOnboardingDuration = (vendorId) => {
  return axios().get(`/vendorHistory/onboading-duration/${vendorId}`);
};

export const httpCreateMultipleAddress = (data) =>
  axios().post(`/address/createMultipleAddress`, data);

export const httpGetPreboardingVendorDetail = (vendorStatus) => {
  return axiosReport().get(
    `/report/getPreboardingVendorDetails?onboardingStatus=${vendorStatus}`
  );
};

export const httpGetEntireVendorsForReporting = (selectedYear) => {
  return axiosReport().get(
    `report/getEntireVendorsForReporting?byYear=${selectedYear}`
  );
};

export const httpGetDetailedStatusReport = () => {
  return axiosReport().get(`report/getDetailedStatusReport`);
};

export const httpGetConfigByType = (type) => {
  return axios().get(`configuration/${type}`);
};

export const httpGetEntireBigTicketVendorsReporting = (selectedYear) => {
  return axiosReport().get(
    `/report/getEntireBigTicketVendorsReporting?byYear=${selectedYear}`
  );
};

export const httpGetEntireVendorsOnboardingStatusReport = (selectedYear) => {
  return axiosReport().get(
    `/report/getEntireVendorsOnboardingStatusReport?byYear=${selectedYear}`
  );
};

export const httpGetVendorStatusCount = (currentYear) => {
  return axiosReport().get("report/getVendorStatusCount?byYear=" + currentYear);
};

export const httpGetNewVendors = () => {
  return axiosReport().get("/report/newVendors");
};

export const httpGetActivePipelineOwner = () => {
  return axiosReport().get("/report/activePipelineOwner");
};

export const httpGetMerchantDashboard = (email) => {
  return axiosReport().get(`/merchant/dashboard/${email}`);
};

export const httpPostEmailAdmin = (submitData, id) => {
  var formData = new FormData();
  for (let i = 0; i < submitData.length; i++) {
    formData.append(`attachments`, submitData[i]);
  }
  return axiosNotification().post(`email/uploadAttachments/${id}`, formData);
};
export const httpDeleteEmailAdmin = (submitData, id) => {
  return axiosNotification().delete(`email/attachment/${id}`, {
    data: submitData,
  });
};

export const httpGetAllNotificationByNotificationType = (notificationType) => {
  return axiosNotification().get(
    `/vmp-notification/all-notification-by-notificationtype/${notificationType}`
  );
};

export const httpPostNotificationFileUpload = (data) => {
  return axiosNotification().post(
    `/vmp-notification/notification-file-upload`,
    data
  );
};

export const httpPostFileUpload = (data) => {
  return axiosDocument().post(`/vmp-document/upload-documents`, data);
};

export const httpPostGenerateContract = (data, contractType) => {
  return axiosDocument().post(`/vmp-document/generate/contract`, data);
};

export const httpGetConsignmentContractStatusById = (
  vendorProfileId,
  contractType
) => {
  return axiosDocument().get(
    `/vmp-document/agreement/signed-status/${vendorProfileId}/${contractType}`
  );
};

export const httpGetDownloadFileByVendorId = (vendorId) => {
  return axiosDocument().get(`/vmp-document/download/${vendorId}`);
};

export const httpPostDeleteUploadedFile = (data) => {
  return axiosDocument().post(`/vmp-document/delete-uploaded-document`, data);
};

export const httpGetLatestThreeNotificationByNotification = () => {
  return axiosNotification().get(
    `/vmp-notification/latest-three-notifications-by-notificationtype/notification`
  );
};

export const httpGetLatestThreeNotificationByResource = () => {
  return axiosNotification().get(
    `/vmp-notification/latest-three-notifications-by-notificationtype/resource`
  );
};

export const httpPostCreateOrUpdateNote = (data) => {
  return axiosNotes().post(`/vendorNote/createOrUpdateNote`, data);
};

export const httpGetNoteByVendorId = (vendorNumber) => {
  return axiosNotes().get(`/vendorNote/getNoteByVendor/${vendorNumber}`);
};

export const httpDeleteNotes = (noteId) => {
  return axiosNotes().delete(`/vendorNote/deleteNotes/${noteId}`);
};

export const httpPutEmailAdmin = (submitData) => {
  const mapRecipts = {
    "Vendor-Primary": "Primary",
    "Vendor-Technical/EDI": "Technical",
    "Vendor-Customer": "CustomerService",
    "Vendor-Shipping": "Shipping",
    Merchant: "Merchant",
    "VDF Merchant Manager": "vdfMerchantOpsManager",
    "VDF Admin": "vdfOpsAdmin",
    "Pipeline Owner": "vdfOpsPipelineOwner",
    "Pipeline Owner (assigned to vendor)": "vdfOpsPipelineOwner",
    "AP Admin": "accountsPayableAdmin",
    "BT Admin": "bigticketAdmin",
    "Vendor-Other": "Other",
  };
  const { recipients, cc } = submitData;
  const reciptsList = recipients.map((recipts) => {
    if (mapRecipts.hasOwnProperty(recipts)) {
      return mapRecipts[recipts];
    }
    return recipts;
  });
  const ccList = cc.map((recipts) => {
    if (mapRecipts.hasOwnProperty(recipts)) {
      return mapRecipts[recipts];
    }
    return recipts;
  });
  submitData.recipients = reciptsList;
  submitData.active = submitData.active === "Yes" ? true : false;
  submitData.filesToUploadList = [];
  submitData.cc = ccList;
  return axiosNotification()({
    url: "/email/templates",
    data: submitData,
    method: "PUT",
  });
};

export const httpGetVendorNumberByDeptNumAndDuns = (
  duns,
  operatingDiv,
  deptNum
) => {
  let rawDuns = duns;
  let formattedDuns = getFormattedDuns(rawDuns);
  return axios().get(
    `/deptvendor/vendorNumberByDeptNumbersAndDuns/${operatingDiv}/${deptNum}/${formattedDuns}`
  );
};

const getFormattedDuns = (rawDuns) => {
  let prefix = "0";
  let stringDuns = rawDuns.toString();

  if (stringDuns.length === 9) {
    return stringDuns;
  } else {
    var remainingLength = 9 - stringDuns.length;
    while (remainingLength != 1) {
      prefix += "0";
      remainingLength--;
    }

    return prefix + stringDuns;
  }
};

export const httpPostMerchantApprovalApprove = (data) =>
  axios().post("/vendorProfile/approveVendor", data);

export const httpPostMerchantApprovalReject = (data) =>
  axios().post("/vendorProfile/rejectVendor", data);

export const httpPostMerchantApprovalViewModify = (data) =>
  axios().post("/vendorProfile/view-modify-merchant-approval", data);

export const httpGetValidateDunsAndCorpName = (
  duns,
  encodeCorpNm,
  encodeUserEmail,
  isPrimaryVendor
) =>
  axios().get(
    `/vendorProfile/validateDunsAndCorpName?duns=${duns}&corpName=${encodeCorpNm}&email=${encodeUserEmail}&isPrimaryVendor=${isPrimaryVendor}`
  );

export const httpPostUpdateVendorProfileInfo = (data) =>
  axios().post("/vendorProfile/updateVendorProfile", data);

export const httpPostHirarchySave = (data) =>
  axios().post("/hierarchy/update-hierarchy", data);

export const httpGetDBMSubmittedVendorDetail = (email) => {
  return axiosReport().get(
    `/report/get-dbm-submitted-vendors?submittedBy=${email}`
  );
};
export const httpGetDBMMEBSubmittedVendorDetail = (email, vendorType) => {
  return axiosReport().get(
    `/report/get-dbm-submitted-vendors?submittedBy=${email}&filterBy=${vendorType}`
  );
};
export const httpGetDBMMEBSubmittedSendEmail = (email, contractType) => {
  return axiosReport().get(
    `/report/get-dbm-submitted-vendors?submittedBy=${email}&filterBy=${contractType}&vendorSigned=false`
  );
};
export const httpPosttDBMMEBSubmittedSendEmail = (
  vendorProfileId,
  contractType,
  businessOwnerEmail
) => {
  const vId = vendorProfileId + "";
  return axiosDocument().get(
    `/vmp-document/re-trigger-business-owner-remainder/${vId}/${contractType}/${businessOwnerEmail}`
  );
};

export const httpGetDbmDropDownData = (userRoleName) => {
  return axios().get(`/admin/getUserRoles/${userRoleName}`);
};

export const httpPostDbmSaveData = (data) =>
  axios().post("/accountsPayable/submit-dbm-or-merchops", data);

export const httpPostRequestDEIApproval = (data) =>
  axios().post("/accountsPayable/request-dei-approval", data);

export const httpPostAPRequestDBMApproval = (data) =>
  axios().post(`/accountsPayable/request-dbm-approval`, data);

export const httpGetMandatoryDocumentStatus = (vendorProfileId) =>
  axios().get(`/vendorProfile/mandatory-document-status/${vendorProfileId}`);

export const httpPostSubmitToDbmOrMerchOps = (vendorData) =>
  axios().post("/accountsPayable/submit-dbm-or-merchops", vendorData);

export const httpGetRetryErrorList = () =>
  axiosMarketplaceVendor().get(`/vendorProfile/getVendorDetailsByStatus/ERROR`);

export const httpPostRetryErrorById = (id) =>
  axiosMarketplaceVendor().post(
    `/vendorProfile/retryMarketplaceRequest/${id}`,
    {}
  );

export const httpPostRequestDVNAuditApproval = (data) =>
  axios().post("/accountsPayable/request-dvn-audit-approval", data);

export const httpGetDocumentCenterSignedUrl = (documentId, userEmail) => {
  return axiosDocument().get(
    `/vmp-document/get-sign-url?documentId=${documentId}&userEmail=${userEmail}`
  );
};

export const httpGetNotificationSignedUrl = (notificationId) => {
  return axiosNotification().get(
    `/vmp-notification/get-sign-url?notificationId=${notificationId}`
  );
};

export const httpGetFreightTermsByOperDiv = (operDiv) => {
  return axios().get(`/freightterms/${operDiv}`);
};

export const httpPostDVNAuditNotes = (data) =>
  axios().post("/accountsPayable/dvn-audit-notes", data);

export const httpGetAllVendorDetail = () => {
  return axiosReport().get(`/merchant/allvendors/getFullDataSet`);
};

export const httpPostAgreementContractCreate = (data) => {
  return axiosDocument().post(`/vmp-document/agreement/create`, data);
};

export const httpGetShippingLocationDetails = (vendorProfileId) =>
  axios().get(`/shipping/location/${vendorProfileId}`);

export const httpPostUpdateShippingLocation = (data) =>
  axios().post("/shipping/location/create-or-update", data);

export const httpGetSellerCentralReports = () => {
  return axiosReport().get(`sellercentral/report`);
};

export const httpGetSellerCentralManageReports = () => {
  return axiosReport().get(`/sellercentral/managereportactivity`);
};

export const httpPostSellerCentralManageReports = (data) => {
  return axiosReport().put(`/sellercentral/updatereportactivity`, data);
};

export const httpGetMerchantStoreLocations = (divisionNumber) => {
  return axios().get(`/merchant/store/locations/${divisionNumber}`);
};

export const httpPostRequestGmmChiefmerchApproval = (data) =>
  axios().post("merchant/request-gmm-or-chiefmerch-approval", data);

export const httpGetConsignementContract = (vendorProfileId, contractType) => {
  return axiosDocument().get(
    `/vmp-document/template/${vendorProfileId}/${contractType}`
  );
};

export const httpPutUpdateDocDetailsByContractType = (contractType, data) => {
  return axiosDocument().put(`/vmp-document/updateby/${contractType}`, data);
};

export const httpGetDocumentLibraryList = () => {
  return axiosDocLibrary().get("/documentlibrary/getmdocuments/list");
};

export const httpGetDocumentLibraryRecentUpdateList = () => {
  return axiosDocLibrary().get("/documentlibrary/getmdocuments/recentupdate");
};

export const httpGetDocumentLibraryDocLinkById = (id) => {
  return axiosDocLibrary().get(
    `/documentlibrary/getmdocuments/linkById/${id}`,
    { responseType: "blob" }
  );
};
export const httpGetManageUserDetails = (vendorId) => {
  return axiosFom().get(`/userdetails/listusers/${vendorId}`);
};
export const httpPostManageUserDetails = (data) => {
  return axiosFom().post(`/userdetails/manageuser`, [data]);
};
export const httpPostDeleteVendorProfileByprofileId = (vendorId, payload) =>
  axios().delete(`/vendorProfile/deleteVendorProfileByprofileId/${vendorId}`, {
    data: payload,
  });
export const httpGetManageUserValidateEmail = (email) => {
  return axiosFom().get(`/userdetails/emailvalidation/${email}`);
};
export const httpPostManageUserAddUser = (data) => {
  return axiosFom().post(`/userdetails/adduser`, data);
};
export const httpGetManageUserParentChildList = (listType) => {
  return axios().get(`/parentchild/vendors?relation=${listType}`);
};
export const httpGetManageUserParentChildHierarchy = (duns, vendorCorpName) => {
  let encodedVendorCorpName = encodeURIComponent(vendorCorpName);
  return axios().get(`/parentchild/vendors/${duns}/${encodedVendorCorpName}`);
};
export const httpPostParentChildConfirmation = (data) => {
  return axios().post(`/parentchild/vendors`, data);
};
export const httpPostMainframeSuffixError = (data) => {
  return axios().post(
    "/accountsPayable/manage-consignment-extra-suffix-dvn",
    data
  );
};
export const httpDeleteNotificationByIdAndType = (id, type) => {
  return axiosNotification().post(`/vmp-notification/delete_notification/${type}/${id}`);
};
export const httpGetParentDunsForSelectedVendor = (relationType, duns) => {
  return axios().get(`/parentchild/vendors?relation=${relationType}&duns=${duns}`);
};
export const httpGetDvnByChildVendorId = (parentVendorId, childVendorId, relationshipType) => {
  return axios().get(`/parentchild/vendors/getdvnbyparentchild/${parentVendorId}/${childVendorId}/${relationshipType}`)
}
export const httpGetAuditByVendorId = (vendorId) => {
  return axiosFom().get(`/audit/vendor/${vendorId}`);
};
export const httpGetAuditForAdmin = () => {
  return axiosFom().get(`/audit/admin`);
};
